'use client';

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from 'react';
import { overlayStack } from '@/app/components/overlays/core/overlayStack';
import type { OverlayRegistrationProps } from '@/app/components/overlays/core/types';
import { getOverlayRegistryKey } from '@/app/components/overlays/utils/getOverlayRegistryKey';

/**
 * Returns whether the given overlay exists anywhere in the active stack.
 */
export function useOverlayStackPresence(props) {
  const $ = _c(4);
  let t0;
  if ($[0] !== props) {
    t0 = getOverlayRegistryKey(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const key = t0;
  let t1;
  if ($[2] !== key) {
    t1 = () => overlayStack.has(key);
    $[2] = key;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useSyncExternalStore(overlayStack.subscribe, t1, _temp);
}
function _temp() {
  return false;
}